import { render, staticRenderFns } from "./ArbsSettingsMunis.vue?vue&type=template&id=a35b2b46&"
import script from "./ArbsSettingsMunis.vue?vue&type=script&lang=js&"
export * from "./ArbsSettingsMunis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports